import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";
import { BannerImage, Container } from "./styles";

const HeaderBanner = () => {
	const { getImage } = useImagePath("cdn");
	const mainBanner = getImage(friendCenterAssets.common.mainBanner);

	return (
		<Container>
			<BannerImage src={mainBanner} alt="Friend Center banner" />
		</Container>
	);
};

export default HeaderBanner;
